import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAmbarVoyageRequest } from '../models/request/ambarVoyage/AddAmbarVoyageRequest';
import { GetAmbarVoyageListPagingAndFilterRequest } from '../models/request/ambarVoyage/GetAmbarVoyageListPagingAndFilterRequest';

export class AmbarVoyageService {
    static async getAmbarVoyageList(_getJustActives?: boolean) {
        try {
            var inputObj = {
                getJustActives: _getJustActives
            };

            console.log('SERVICE CALL - getAmbarVoyageList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/getAmbarVoyageList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    // Sefer detayindaki Aktif / Pasif isareti: teslimle kapanan sefer yeniden acilir ya da elle pasife alinir.
    static async seferAktifligiDegistir(_id: string, _aktif: boolean) {
        try {
            var inputObj = { id: _id, aktif: _aktif };

            console.log('SERVICE CALL - seferAktifligiDegistir', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/SeferAktifligiDegistir', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Web'den Seferi Bitir (16.10.2026): bitis zamani seferdeki siparislerin en gec teslim zamani; eksikse sunucu hata dondurur. */
    static async seferiBitir(_id: string) {
        try {
            var inputObj = { id: _id };

            console.log('SERVICE CALL - seferiBitir', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/SeferiBitir', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Sefer guzergahi onizleme (15.10.2026): ilk siparis 1. sirada sabit, kalanlar en az KM ile dizilir; kaydetmez. */
    static async guzergahDiz(_ambarVoyageId: string, _ilkAmbarId?: string) {
        try {
            var inputObj = { ambarVoyageId: _ambarVoyageId, ilkAmbarId: _ilkAmbarId };

            console.log('SERVICE CALL - guzergahDiz', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/GuzergahDiz', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Sefer guzergahi (15.10.2026): verilen (ekrandaki) sirayla bacak KM, sure ve yol cizgileri. */
    static async guzergah(_ambarVoyageId: string, _sira?: string[]) {
        try {
            var inputObj = { ambarVoyageId: _ambarVoyageId, sira: _sira };

            console.log('SERVICE CALL - guzergah', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/Guzergah', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAmbarVoyageList(inputObj: GetAmbarVoyageListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportAmbarVoyageList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/exportAmbarVoyageList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAmbarVoyageListPagingAndFilter(inputObj: GetAmbarVoyageListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetAmbarVoyageListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/GetAmbarVoyageListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addAmbarVoyage(inputObj: AddAmbarVoyageRequest) {
        try {
            console.log('SERVICE CALL - AddAmbarVoyage', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/AddAmbarVoyage', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteAmbarVoyage(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteAmbarVoyage', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/deleteAmbarVoyage', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAmbarVoyageById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getAmbarVoyageById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarVoyage/getAmbarVoyageById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}